<template>
  <div
    ref="embedContainer"
    class="main-container"
    :style="{ background: event ? event.branding.tertiaryColor : '#FFFFFF' }"
  >
    <!-- <b-button @click="captureAudio">Get Audio</b-button> -->
    <div class="card card-overlay">
      <div class="card-content">
        <b-field :label="eventLabel" class="mt-3"></b-field>
        <b-field v-if="!audioConnected && !goBtnClicked && !isTestListener" :label="$t('hearTransDesc')" class="mt-3">
          <LanguagePicker
            v-model="userLang"
            :whitelist="langWhiteList"
            :change-local="false"
            :loading="loadingIndicator"
            :disabled="loadingIndicator"
          />
        </b-field>
        <b-button
          v-if="!audioConnected && !goBtnClicked && !isTestListener"
          type="is-primary"
          icon-right="play"
          :loading="loadingIndicator"
          :disabled="!langWhiteList.concat(['zxx']).includes(userLang)"
          @click="startJoinRoom"
        >
          {{ $t("hearTrans") }}
        </b-button>
        <div style="margin-top: 18px">
          <span style="color: #404040; font-size: 12px">{{ $t("poweredByQonda") }}</span>
          <a style="color: #404040; font-size: 12px" class="help-embedded" @click="showHelp"> | {{ $t("help") }}</a>
          <a style="color: #404040; font-size: 12px" class="help-embedded" @click="openFeedbackPage">
            | Leave Feedback</a
          >
          <Modal v-show="showHelpTxt" @close="showHelp">
            <template v-slot:body>
              {{ $t("embedHelpText") }}
            </template>
          </Modal>
        </div>

        <div v-if="goBtnClicked && !audioConnected">
          {{ $t("noUsersToListen") }}
        </div>

        <div v-if="(audioConnected && goBtnClicked) || isTestListener">
          Selected Language:<br />
          <b-select v-model="userLang" placeholder="Select a language" class="my-2">
            <option v-for="lang in langWhiteList" :key="lang" :value="lang">
              {{ lang }}
            </option>
          </b-select>
          <div v-if="activeTranslator">
            <span>Listening to: </span>&nbsp;
            <b>{{ consumeLang }}</b>
          </div>
          <av-media
            :media="audioMedia"
            :type="'frequ'"
            :canv-height="60"
            :line-color="event.branding.primaryColor"
            :frequ-line-cap="true"
            :line-width="0.8"
          />
          <b-button
            size="is-small"
            :type="listenerMute ? 'is-danger' : 'is-success'"
            outlined
            focused
            :icon-right="listenerMute ? 'volume-off' : 'volume-high'"
            @click="toggleListenerMute"
          >
            {{ listenerMute ? "Sound Off" : "Sound On" }}
          </b-button>
          <!-- Uncomment to activate subtitle  -->
          <!-- <p>{{ $t("subtitle") + ":" }}</p>
          <b-button
            v-if="!transcriptionStarted"
            size="is-small"
            type="is-primary"
            outlined
            @click="transcriptionOnClicked"
          >
            {{ $t("turnOnSubtitle") }}
          </b-button>
          <b-button
            v-if="transcriptionStarted"
            size="is-small"
            type="is-primary"
            outlined
            @click="transcriptionOffClicked"
          >
            {{ $t("turnOffSubtitle") }}
          </b-button> -->
        </div>
      </div>
    </div>
    <!-- <div v-if="transcriptionStarted" class="transcription" v-html="transcriptionResult"></div> -->
    <AudioHandler :v-if="audioConnected" :consume-lang="consumeLang" :is-embed="isEmbed" @lang-peers="setAudioMedia" />
    <p class="browser-info">
      {{ `Browser: ${browserDetails.name} | Version: ${browserDetails.version} | OS: ${browserDetails.os}` }}
    </p>
  </div>
</template>
<script>
/**
 * Audio only widget, for listener to join the conference
 * same functionality as joining Room as a viewer except no video
 * @displayName Embed Overlay
 */
import LanguagePicker from "../LanguagePicker.vue";
import { mapState } from "vuex";
import Modal from "./Modal";
import AudioHandler from "./AudioHandler.vue";
import RoomClient from "../../mediasoup-client/RoomClient.js";
import deviceInfo from "../../mediasoup-client/deviceInfo.js";
import Logger from "../../mediasoup-client/Logger";
import { db } from "@/firebase";

export default {
  name: "EmbedOverlay",
  components: {
    Modal,
    AudioHandler,
    LanguagePicker,
  },
  props: {},
  data() {
    return {
      logger: new Logger(`EmbedOverlay.vue`),
      isEmbed: true,
      clientRole: "listener",
      showHelpTxt: false,
      userLang: "zxx",
      activeTranslatorUid: null,
      event: undefined, // filled with firebase
      loadingIndicator: false,
      connected: false,
      roomClient: null,
      goBtnClicked: false,
      isTestListener: false,
      audioMedia: null,
      audioStream: new MediaStream(),
      transcribeBtnVisible: true,
      msg: `IPs:
        firestore.googleapis.com -> floating ips
        socket.qonda.cloud -> floating ips
        mediasoup.qonda.cloud -> 18.159.85.247
        v2.goqonda.io -> 151.101.1.195 | 151.101.65.195
        app.goqonda.io -> 151.101.1.195 | 151.101.65.195
        Für Konferenz Admins: cloudfunctions.net

        Destination ports - UDP/TCP Ports:
        80; 443; 4443; 5000;40000-49999`,
      msgHtml: `<p>Could not connect to Mediasoup API. Either the server is unreachable 
        or your firewall blocks the connection. Contact your IT administrator to allow the following 
        IPs and Ports:</p><br>
        <p>firestore.googleapis.com -> floating ips</p>
        <p>socket.qonda.cloud -> floating ips</p>
        <p>mediasoup.qonda.cloud -> 18.159.85.247</p>
        <p>v2.goqonda.io -> 151.101.1.195 | 151.101.65.195</p>
        <p>app.goqonda.io -> 151.101.1.195 | 151.101.65.195</p>
        <p>Für Konferenz Admins: cloudfunctions.net</p><br>
        <p>Destination ports - UDP/TCP Ports:</p>
        <p>80; 443; 4443; 5000;40000-49999</p>`,
    };
  },
  computed: {
    ...mapState({
      mediasoupConfig: (state) => state.mediasoup.mediasoupConfig,
      mediasoupId: (state) => state.mediasoup.mediasoupId,
      audioConnected: (state) => state.mediasoup.audioConnected,
      consumeLang: (state) => state.mediasoup.consumeLang,
      produceLang: (state) => state.mediasoup.produceLang,
      websocketReady: (state) => state.mediasoup.websocketReady,
      transcriptionResult: (state) => state.mediasoup.transcriptionResult,
      transcriptionStarted: (state) => state.mediasoup.transcriptionStarted,
      browserDetails: (state) => state.mediasoup.browserDetails,
      consumeVolume: (state) => state.mediasoup.consumeVolume,
      floorVolume: (state) => state.mediasoup.floorVolume,
      listenerMute: (state) => state.mediasoup.listenerMute,
    }),
    eventLabel() {
      return this.event ? `Event Title: ${this.event.name}` : `Event Title: -- -- --`;
    },
    langWhiteList() {
      if (this.event) {
        return this.event.langComb
          ? this.event.langComb
              .map((lc) => [lc.lang1, lc.lang2])
              .flat()
              .filter((l, i, arr) => arr.indexOf(l) == i)
          : [];
      } else {
        return [];
      }
    },
    activeTranslator() {
      return this.activeTranslatorUid ? this.translators[this.activeTranslatorUid] : null;
    },
  },
  watch: {
    async websocketReady(val) {
      this.logger.info(`WebSocket ready: ${val}`);

      if (val) {
        await this.saveJoinedUsersToStore(await this.getJoinedUsers());
        await this.roomClient.join();
      }
    },
    async userLang(val) {
      this.$store.commit("mediasoup/set_consumeLang", val.toUpperCase());
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", async () => {
      this.roomClient?.close();
    });
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      await this.validateEvent();

      let mediasoupId = String(Math.random() * 10000);
      this.logger.info(`OWN PEER ID : ${mediasoupId}`);
      this.$store.commit("mediasoup/set_mediasoupId", mediasoupId);
      this.$store.commit("mediasoup/set_embed", true);
      this.$store.commit("mediasoup/set_consumeLang", this.userLang.toUpperCase());
      this.$store.commit("mediasoup/set_role", "listener");
      this.$store.commit("mediasoup/set_floor", false);

      this.isTestListener = this.$route.query.test === "true";

      if (this.isTestListener) {
        this.joinAsTestUser();
      }
    },
    async validateEvent() {
      const eventRef = db.doc(
        `organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`,
      );
      const eventData = (await eventRef.get()).data();

      if (!eventData.name) {
        const alert = `Event data not found! Please try again later.`;
        this.openSnackBar(alert, "is-top", "Close", () => window.location.replace(`http://www.goqonda.io`));
      }
    },
    setUserLangauge() {
      try {
        var deviceLang = navigator.language || navigator.userLanguage;

        if (deviceLang && this.$i18n.availableLocales.includes(deviceLang.substr(0, 2))) {
          this.$i18n.locale = deviceLang.substr(0, 2);
        } else {
          this.$i18n.locale = "en";
        }
      } catch (error) {
        this.$i18n.locale = "en";
        this.logger.error(error);
      }
    },
    muteListener() {
      this.$store.commit("mediasoup/set_listener_mute", true);
    },
    unMuteListener() {
      this.$store.commit("mediasoup/set_listener_mute", false);
    },
    toggleListenerMute() {
      this.$store.commit("mediasoup/set_listener_mute", !this.listenerMute);
    },
    openFeedbackPage() {
      window.open("https://www.provenexpert.com/qonda/d6tn/", "_blank");
    },
    transcriptionOnClicked() {
      this.$store.commit("mediasoup/set_transcriptionOnClicked", true);
    },
    transcriptionOffClicked() {
      this.$store.commit("mediasoup/set_transcriptionOffClicked", true);
    },
    /**
     * Sets the audio media for visualization.
     */
    setAudioMedia(langPeers) {
      if (langPeers && langPeers.length > 0) {
        const audiostream = new MediaStream();
        audiostream.addTrack(langPeers[0].audioConsumer._track);
        this.audioMedia = audiostream;
      }
    },
    openSnackBar(message, position, actionText, onAction) {
      this.$buefy.snackbar.open({
        message,
        position,
        actionText: actionText,
        indefinite: true,
        onAction,
      });
    },
    async saveJoinedUsersToStore(joinedUsers) {
      await this.roomClient.storeJoinedPeers(joinedUsers);
      await this.roomClient.storeAllJoinedPeers(joinedUsers);
    },
    /**
     * Gets joined users and save them in vuex
     */
    async getJoinedUsers() {
      let res = undefined;

      try {
        res = await fetch(`${this.mediasoupConfig.MediasoupExpressAppUrl}joinedusers/${this.$route.params.eventId}/`);
      } catch (error) {
        this.logger.error(`Could not connect to Mediasoup Express API`, error);

        this.openSnackBar(this.msgHtml, "is-top", "Copy & Close", () => {
          navigator.clipboard.writeText(this.msg);
        });

        throw "File: RoomClient.js, Could not connect to Mediasoup API";
      }

      if (res.status && res.status !== 200) {
        throw new Error("Internal server error in Mediasoup Express API");
      }

      try {
        return await res.json();
      } catch (error) {
        this.logger.error("Could not get joined users from Mediasoup Express API!", error);
      }
    },
    /**
     * Shows the Help modal with the Mediasoup Id for the User to report issues
     * @public
     */
    showHelp() {
      this.showHelpTxt = !this.showHelpTxt;
    },
    joinAsTestUser() {
      this.userLang = "eng";
      this.startJoinRoom();
    },
    async startJoinRoom() {
      this.goBtnClicked = true;
      await this.createRoomClientAndConnect();
    },
    /**
     * Creates roomClient and connects to websocket signaling server
     * @public
     */
    async createRoomClientAndConnect() {
      this.roomClient = new RoomClient({
        mediasoupConfig: this.mediasoupConfig,
        roomId: this.$route.query.roomId || this.$route.params.eventId,
        peerId: this.mediasoupId,
        displayName: this.displayName || "default",
        device: deviceInfo(),
        role: "listener",
        isFloor: this.role === "host",
        handlerName: this.$route.query.handler,
        useSimulcast: this.$route.query.simulcast !== "false",
        useSharingSimulcast: this.$route.query.sharingSimulcast !== "false",
        forceTcp: this.$route.query.forceTcp === "true",
        produce: false,
        consume: true,
        forceH264: this.$route.query.forceH264 === "true",
        forceVP9: this.$route.query.forceVP9 === "true",
        svc: this.$route.query.svc,
        externalVideo: this.$route.query.externalVideo === "true",
        e2eKey: this.$route.query.e2eKey,
        produceLang: this.produceLang,
        consumeLang: this.consumeLang,
        eventId: this.$route.params.eventId,
        testViewer: true, // Just for test purpose to play audio
      });

      this.roomClient._connect();
    },
  },
  firestore() {
    return {
      event: db.doc(`organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`),
    };
  },
};
</script>
<style scoped>
.control {
  width: fit-content;
}
.main-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-overlay {
  max-width: 700px;
  min-width: 400px;
  width: 50%;
  margin: 100px;
  padding: 0 30px 0 20px;
  border-radius: 25px;
}
.transcription {
  z-index: 99999;
  margin: 0 30px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 2px;
  padding: 0 5px 0 5px;
}
.browser-info {
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  background-color: white;
  padding: 3px;
  border-radius: 2px;
  margin-bottom: 2px;
}
</style>
